import React from 'react'
import {
  DateRange,
  DateRangePicker,
  DateRangePickerProps
} from '@mui/x-date-pickers-pro'
import moment, { Moment } from 'moment'

export const calendarRowTextFieldStyles = (direction: 'left' | 'right') => ({
  '& .MuiOutlinedInput-root': {
    fontSize: '12px',
    borderTopRightRadius: direction === 'right' ? '0' : '4px',
    borderBottomRightRadius: direction === 'right' ? '0' : '4px',
    borderTopLeftRadius: direction === 'right' ? '4px' : '0',
    borderBottomLeftRadius: direction === 'right' ? '4px' : '0',
    '& .MuiOutlinedInput-notchedOutline': {
      borderRight: direction === 'right' ? 'none !important' : '',
      borderLeft: direction === 'left' ? 'none !important' : '',
      top: '0 !important',
      '& *': {
        display: 'none'
      }
    }
  },
  '& .MuiInputLabel-root': {
    display: 'none'
  }
})

const DateDateRangePicker = ({
  value,
  onChange,
  minDate,
  ...props
}: Omit<DateRangePickerProps<Date>, 'onChange'> & {
  onChange?: (value: [Date | null, Date | null]) => void
}) => {
  const handleOnChange = (dateRange: DateRange<Moment>) => {
    onChange?.([dateRange[0]?.toDate() ?? null, dateRange[1]?.toDate() ?? null])
  }
  return (
    <DateRangePicker<Moment>
      onChange={handleOnChange}
      minDate={minDate && moment(minDate)}
      value={
        value && [
          value[0] ? moment(value[0]) : null,
          value[1] ? moment(value[1]) : null
        ]
      }
      {...(props as any)}
    />
  )
}
export default DateDateRangePicker
